module.exports = __webpack_public_path__ + "img/statistics_icon2.493c0f34.png";